<template>
  <div>
    <div class="clearfix pb-2">
      <h6 class="float-start">{{ compTitle }}</h6>
      <button @click="add" type="button" class="float-end btn btn-sm btn-primary">Add</button>
    </div>
<!--    {{value}}-->
    <div v-if="value.length < 1">
      No users added
    </div>
    <div v-for="u in value" class="p-1 pl-2 bg-light border-bottom border-2">
      <button type="button" @click="remove(u)" class="float-start btn btn-icon btn-sm btn-bg-light btn-active-color-danger"><i class="fa fa-trash"></i></button>
      <div>
        <div class="fw-bold">{{$_.get(u.profile, 'first_name')}} {{$_.get(u.profile, 'last_name')}}</div>
        <span class="small">{{ u.email }}</span>
      </div>
    </div>
  </div>
</template>

<script>
import UserSelectorModal from "./UserSelectorModal.vue";

export default {
  name: "UserSelector",
  props: {
    value: {
      default: () => [],
    },
    title: {
      default: "Relationship"
    },
    // users: {
    //   default: () => []
    // },
    // removeCb: {
    //   default: () => {
    //   },
    // }
  },
  data() {
    return {
      // users: this.value,
      create_event: `user-selected-${_.random(true)}`,
    }
  },
  computed: {
    compTitle(){
      return this.title || "Relationship"
    }
  },
  mounted() {
    this.$root.$on(this.create_event, (u) => {
      let users = this.value
      u.forEach(ele => users.push(ele))
      this.$emit('input', users)
    })
  },
  destroyed() {
    this.$root.$off(this.create_event)
  },
  methods: {
    add() {
      this.$modal.show(UserSelectorModal,
          {
            create_event: this.create_event,
          },
          {height: "auto", shiftY: 0, scrollable: true},
      );
    },
    remove(user) {
      const wiped = this.$_.reject(this.value, {id: user.id})
      this.$emit('input', wiped)
    }
  }
}
</script>